import { ContainerCard, CardStyle, images } from "../styles";
import { Card } from "antd";

export default function QuintaSantaBarbara() {
  const { Meta } = Card;

  return (
    <ContainerCard>
      <Card
        hoverable
        style={CardStyle}
        cover={
          <a href="/empreendimentos/autorizacao/autorizacao-quinta-santa-barbara.docx">
            <img
              alt="autorizacao"
              src={images.autorizacao}
              style={{ width: "100%", height: "auto" }} // Ajuste o tamanho da imagem
            />
          </a>
        }
      >
        <Meta
          title="Autorização de Hospedagem"
          description="Última atualização em: 12/09/2024"
        />
      </Card>
    </ContainerCard>
  );
}
